// extracted by mini-css-extract-plugin
export var divider = "_s3-0";
export var systemMessage = "_s3-1";
export var systemMessageWrapper = "_s3-2";